<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Contract Manufacturing'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div class="tit"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>IVD Contract Manufacturing Solutions</div>
				<div class="txt"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Put our decades of diagnostic development experience to use. CorDx provides in vitro<br />diagnostics (IVD) contract manufacturingsolutions fofor healthcare companies of all sizes –<br />from startups tolarge enterprises.</div>
				<div
					class="btn_box_more btn_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="500"
					data-aos-offset="0"
					data-aos-once="true"
					@click="goContact"
				>
					Work With CorDx<img src="../../assets/img/组 32@2x.png" />
				</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"	
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/20230906-094456.webp" />
			</div>
			<!--banner-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							A Pathway for Bringing Your IVD Products to Life
						</div>
						<div class="text">
							When you choose CorDx to manufacture your IVD products, you get end-to-end diagnostic capabilities, a world-class supply chain, and fully compliant systems, all run by a global team of IVD experts ready to bring your diagnostic solutions to the market. Our team is well-versed in the latest IVD technology, allowing us to quickly produce a range of high-quality products fofor applications including:
						</div>
						<div class="btn_box_more btn_box" @click="goContact">
							Work With CorDx<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
					<div class="right"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="right_main">
							<div class="el">● Respiratory Diseases</div>
							<div class="el">● Infectious Diseases</div>
							<div class="el">● Sexually Transmitted Diseases</div>
							<div class="el">● Fertility Monitoring</div>
							<div class="el">● Drugs of Abuse</div>
							<div class="el">● Cardiac Markers</div>
							<div class="el">● Tumor Markers</div>
							<div class="el">● Health TeTests</div>
							<div class="el">● Blood Glucose</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_3_main">
					<div class="block_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="block_el" style="background-color: #FBFEFC;">
							<img src="../../assets/img/img@2x_副本.webp" />
							<div class="title">
								End-to-End IVD Development
							</div>
							<div class="text">
								Our flexible IVD manufacturing solutions cover each step of your product lifecycle. We cover everything including:
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Product design and development</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">DFMEA and DFM review prior to tool fabrication</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Low-cost prototyping and tooling for proof-of-concepts</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Design optimization</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Full-volume production</div>
							</div>
						</div>
						<div class="block_el" style="background-color: #FEFCFC;">
							<img src="../../assets/img/蒙版组 1@2x_副本2.webp" />
							<div class="title">
								Integrated Supply Chain​
							</div>
							<div class="text">
								CorDx owns its supply chain from bottom to top to ensure the world has access to affordable, user-friendly & precise diagnostics products offered at competitive pricing.<br />
								Integrated supply chain benefits include:
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Quality Control​</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Accessibility</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Cost Savings​</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Flexibility</div>
							</div>
						</div>
						<div class="block_el" style="background-color: #F9FAFE;">
							<img src="../../assets/img/蒙版组 1@2x (1)_副本2.webp" />
							<div class="title">
								Quality Systems
							</div>
							<div class="text">
								CorDx maintains a steadfast focus on quality management systems for medical devices.
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">Global：<br />100% GMP compliant</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">China:<br />ISO 13485:2016<br />ISO 9001:2015<br />Verified by TUV</div>
							</div>
							<div class="el_box">
								<div class="left">●</div>
								<div class="right">US:<br />ISO 13485:2016<br />Verified by TUV</div>
							</div>
						</div>
					</div>
					<div class="block_btn">
						<div class="btn_box_more btn_box" @click="goContact">
							Work With CorDx<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="left"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							World-leading IVD Manufacturing Capacity
						</div>
						<div class="text">
							CorDx maintains a combined 3+ million square feet ofmanufacturing facilities worldwide. We work with the latestIVD technology, allowing us to quickly produce a range ofhigh-quality IVD products.
						</div>
					</div>
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/contract-manufacturing/pc/block_1.webp" />
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/contract-manufacturing/pc/block_2.webp" />
					</div>
					<div class="right"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">About CorDx</div>
						<div class="text">
							CorDx manufactures point-of-care and over-the-counter rapid diagnostic products across a variety of categories, including infectious disease, reproductive & sexual health, substance abuse, and other health and marker tests. With authorization for use in the US (FDA), Europe (CE Mark) and China (NMPA), CorDx tests are known for their comfofort, speed and accuracy.
							<!-- Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors healthcare providers, and patients alike. -->
						</div>
						<div class="text">
							Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors healthcare providers, and patients alike.
						</div>
						<div class="img_box">
							<img src="../../assets/contract-manufacturing/pc/block_3.webp" />
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6">
				<div class="block_6_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Let CorDx Manufacture Your Next<br />IVD Breakthrough
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						We partner with organizations of all sizes to develop, manufacture, and<br />distribute diagnostics that empower patients to improve their health. Work<br />with CorDx to bring your IVD solutions to life.
					</div>
					<div
						class="btn_box_more btn_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goContact"
					>
						Talk to CorDx<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块6-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Contract Manufacturing - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goContact() {
			this.$router.push({ path: '/contact' });
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	color: #000000;
	//块6
	.block_6{
		padding: 100px 0;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_6_main{
			width: 1140px;
			margin: 0 auto;
			text-align: center;
			.btn_box{
				margin-top: 70px;
			}
			.text{
				padding-top: 30px;
				font-size: 30px;
			}
			.title{
				font-size: 60px;
			}
		}
	}
	//块5
	.block_5{
		padding: 100px 0;
		.block_5_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			.right{
				flex: 1;
				.img_box{
					padding-top: 40px;
					img{
						width: 180px;
					}
				}
				.text{
					padding-top: 20px;
					font-size: 18px;
				}
				.title{
					font-size: 60px;
				}
			}
			.left{
				flex: 1;
				text-align: center;
				img{
					width: 340px;
				}
			}
		}
	}
	//块4
	.block_4{
		padding: 100px 0;
		background-color: #F8FBFF;
		.block_4_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			.right{
				width: 550px;
				.img_box{
					img{
						width: 100%;
					}
				}
			}
			.left{
				flex: 1;
				padding-right: 90px;
				.text{
					padding-top: 30px;
					font-size: 18px;
				}
				.title{
					font-size: 48px;
				}
			}
		}
	}
	//块3
	.block_3{
		width: 100%;
		padding: 100px 0 100px 0;
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			.block_btn{
				text-align: center;
				.btn_box{
					margin-top: 60px;
				}
			}
			.block_box{
				display: flex;
				.block_el{
					flex: 1;
					margin: 0 8px;
					padding: 20px 20px 50px 20px;
					.el_box{
						display: flex;
						padding: 3px 0;
						.right{
							flex: 1;
							padding-left: 10px;
							font-size: 18px;
						}
						.left{
							width: auto;
							font-size: 18px;
						}
					}
					.text{
						padding: 15px 0 20px 0;
						font-size: 18px;
					}
					.title{
						padding-top: 30px;
						font-size: 36px;
					}
					img{
						width: 100%;
					}
				}
			}
		}
	}
	//块2
	.block_2{
		padding: 100px 0;
		background-color: #F8FBFF;
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			.right{
				flex: 1;
				.right_main{
					padding-left: 100px;
					.el{
						padding-bottom: 4px;
						font-size: 28px;
					}
				}
			}
			.left{
				flex: 1;
				.btn_box{
					margin-top: 45px;
					background-color: #F8FBFF;
				}
				.text{
					padding-top: 30px;
					font-size: 18px;
				}
				.title{
					font-size: 45px;
				}
			}
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.btn_box{
			margin-top: 30px;
		}
		.tit{
			font-size: 60px;
		}
		.txt{
			font-size: 24px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 2px 28px 0 28px;
		height: 45px;
		line-height: 45px;
		font-size: 22px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
